import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/x-charts/themeAugmentation";

import "./types";
import { defaults } from "./defaults";

const createAppTheme = () => {
    return createTheme(defaults);
};

const theme = createAppTheme();

export default theme;
export { createAppTheme };
